export enum Path {
  Blank = '',
  Root = '/',
  WildCard = '**',
  Home = 'home',
  NewReservation = 'new-reservation',
  Reservations = 'reservations',
  Warehouse = 'warehouse',
  GpsLink = 'gps-link',
  AllReservations = 'all-reservations',
  AllWarehouses = 'warehouses',
  DailyReports = 'daily-reports',
  Articles = 'articles',
  ArticleParam = 'article-id',
  Cart = 'cart',
}
